<template>
  <main class="pi-wrap">
    <div class="pi-inner">

      <!-- 헤더 -->
      <div class="pi-header">
        <div class="pi-header-badge">🗺️ 상품 문의</div>
        <h1 class="pi-title">여행, 궁금한 것이 있으신가요?</h1>
        <p class="pi-sub">담당 직원이 확인 후 빠르게 답변드립니다<br>
          <span class="pi-kakao">카카오톡 플러스친구로 문의하시면 더욱 빠른 답변을 받으실 수 있어요</span>
        </p>
      </div>

      <!-- 상품 배지 -->
      <div class="pi-product-badge" v-if="productId">
        <i class="bi bi-tag-fill"></i>
        <span>상품코드</span>
        <strong>{{ productId }}</strong>
      </div>

      <!-- 폼 카드 -->
      <div class="pi-card">

        <!-- 개인정보 동의 아코디언 -->
        <div class="pi-agree-wrap" :class="{ open: agreeOpen }">
          <button class="pi-agree-toggle" @click="agreeOpen = !agreeOpen">
            <span class="pi-agree-left">
              <input type="checkbox" v-model="ruleAgree" ref="chb_ruleAgree"
                class="pi-checkbox" @click.stop />
              <span><span class="pi-req">[필수]</span> 개인정보 수집 및 이용동의</span>
            </span>
            <i class="bi" :class="agreeOpen ? 'bi-chevron-up' : 'bi-chevron-down'"></i>
          </button>
          <div class="pi-agree-body" v-show="agreeOpen">
            <h4>1. 개인정보 수집 및 이용목적</h4>
            <p>엔타비는 개인정보를 다음의 목적을 위해 처리합니다.</p>
            <ul>
              <li>홈페이지 회원가입 및 관리: 본인 식별·인증, 회원자격 유지·관리 등</li>
              <li>서비스 제공: 물품배송, 콘텐츠 제공, 요금결제·정산 등</li>
              <li>마케팅 및 광고 활용: 신규 서비스 개발, 이벤트 및 광고성 정보 제공 등</li>
            </ul>
            <h4>2. 개인정보 수집 항목</h4>
            <ul>
              <li>회원가입/관리: 이메일, 휴대전화번호, 비밀번호, 로그인ID, 성별, 생년월일, 이름</li>
              <li>상담 및 여행 예약: 이메일, 휴대전화번호, 이름, 여권사본 등</li>
              <li>대금결제: 신용카드정보, 은행계좌정보</li>
            </ul>
            <h4>3. 개인정보 보유 및 이용기간</h4>
            <ul>
              <li>신용정보 수집/처리 기록: 3년</li>
              <li>소비자 불만 또는 분쟁처리 기록: 3년</li>
              <li>대금결제 및 재화 공급 기록: 5년</li>
              <li>계약 또는 청약철회 기록: 5년</li>
              <li>표시/광고 기록: 6개월</li>
            </ul>
          </div>
        </div>

        <div class="pi-divider"></div>

        <!-- ① 제목 -->
        <div class="pi-field">
          <label class="pi-label">문의 제목 <span class="pi-req">*</span></label>
          <input type="text" maxlength="22" class="pi-input"
            placeholder="문의 제목을 입력해주세요"
            ref="txt_reqTitle" v-model="reqInfo.reqTitle" />
        </div>

        <!-- ② 성명 + 인원 -->
        <div class="pi-row">
          <div class="pi-field">
            <label class="pi-label">성명 <span class="pi-req">*</span></label>
            <input type="text" maxlength="12" class="pi-input"
              placeholder="성명을 입력해주세요"
              ref="txt_reqPersonName" v-model="reqName" />
          </div>
          <div class="pi-field">
            <label class="pi-label">인원수</label>
            <input type="number" min="0" max="15" class="pi-input"
              placeholder="인원수 (선택)"
              ref="txt_perCnt" v-model="reqInfo.perCnt" />
          </div>
        </div>

        <!-- ③ 이메일 + 연락처 -->
        <div class="pi-row">
          <div class="pi-field">
            <label class="pi-label">이메일 <span class="pi-req">*</span></label>
            <input type="email" maxlength="40" class="pi-input"
              placeholder="이메일을 입력해주세요"
              ref="txt_cEmail" v-model="reqInfo.reqEmail" />
          </div>
          <div class="pi-field">
            <label class="pi-label">연락처 <span class="pi-req">*</span></label>
            <input type="text" maxlength="11" class="pi-input"
              placeholder="숫자만 입력 (01012345678)"
              ref="txt_cTel" v-model="reqTel" />
          </div>
        </div>

        <!-- ④ 문의내용 -->
        <div class="pi-field">
          <label class="pi-label">문의내용 <span class="pi-req">*</span></label>
          <textarea class="pi-textarea" maxlength="248"
            placeholder="문의하실 내용을 자유롭게 입력해주세요 (250자 이내)"
            ref="txt_reqSpRemarks" v-model="reqInfo.reqSpRemarks" />
          <div class="pi-char-count">{{ (reqInfo.reqSpRemarks || '').length }} / 248</div>
        </div>

        <!-- 버튼 -->
        <div class="pi-btns">
          <button class="pi-btn pi-btn-cancel" @click="goBack()">
            취소
          </button>
          <button class="pi-btn pi-btn-submit" @click="requestInsert()">
            <i class="bi bi-send"></i> 문의 등록
          </button>
        </div>

      </div>
    </div>
  </main>
</template>

<script>
export default {
  data() {
    return {
      ruleAgree:  false,
      agreeOpen:  false,
      reqInfo:    {
        reqTitle:    '',
        perCnt:      '',
        reqEmail:    '',
        reqSpRemarks: '',
      },
      reqName: '',
      reqTel:  '',
    };
  },

  created() {
    this.user      = this.$store.state.user;
    this.productId = this.$route.query.productId;
    this.salesRoute = this.$route.query.salesRoute;

    if (this.$store.state.user.handlerId != undefined) {
      this.userInfo = this.$store.state.user.handlerId
    } else if (this.$store.state.user.email != undefined) {
      this.userInfo = this.$store.state.user.email
    } else {
      this.userInfo = ""
    }

    if (this.user.joinFlag === "K" || this.user.joinFlag === "E" || this.user.joinFlag === "H" || this.user.joinFlag === "M") {
      this.k_name = (!this.user.nickname) ? "" : this.user.nickname;
      let kakaoPhone = ""
      if (this.user.alimCallC != undefined && this.user.alimCallC.charAt(0) === '+') {
        kakaoPhone = this.user.alimCallC.replace("+82 ", "0")
      } else {
        kakaoPhone = this.user.alimCallC
      }
      this.k_tel = (!this.user.alimCallC) ? "" : kakaoPhone.replace(/-/g, "");
    } else {
      this.k_name = this.user.name;
      this.k_tel  = (!this.user.mobile) ? "" : this.user.mobile.replace(/-/g, "");
    }

    this.reqName = this.k_name
    this.reqTel  = this.k_tel
  },

  mounted() {
    if (!this.$store.state.user.email || this.$store.state.user.email == undefined) {
      var swal = require('sweetalert2');
      swal.fire({ title: '', text: '로그인 후 이용해주세요.', icon: 'warning' });
      this.$router.push({ path: '/b2CLogin', query: { st: "Y" } });
    }
    window.scrollTo(0, 0);
  },

  methods: {
    async requestInsert() {
      const date      = new Date(+new Date() + 3240 * 10000).toISOString().split("T")[0]
      const time      = new Date().toTimeString().split(" ")[0];
      let today       = date + ' ' + time;
      let timeStamp   = new Date().getTime();
      let iqCode      = "IQ-" + date.replace(/-/g, '') + "-" + timeStamp;
      this.reqInfo.iqCode = iqCode;

      if (!this.ruleAgree) {
        this.$refs.chb_ruleAgree.focus();
        return this.$swal.fire("", "개인정보 수집 동의가 필요합니다.", "warning");
      }
      if (!this.reqInfo.reqTitle) {
        this.$refs.txt_reqTitle.focus();
        return this.$swal.fire("", "문의 제목을 입력해주세요.", "warning");
      }
      if (!this.reqName) {
        this.$refs.txt_reqPersonName.focus();
        return this.$swal.fire("", "성명을 입력해주세요.", "warning");
      }
      if (!this.reqInfo.reqEmail) {
        this.$refs.txt_cEmail.focus();
        return this.$swal.fire("", "이메일을 입력해주세요.", "warning");
      }
      if (!/^[\w-]+(\.[\w-]+)*@([\w-]+\.)+[a-zA-Z]+$/.test(this.reqInfo.reqEmail)) {
        this.$refs.txt_cEmail.focus();
        return this.$swal.fire('', '이메일 형식이 올바르지 않습니다.', 'question');
      }
      if (!this.reqTel) {
        this.$refs.txt_cTel.focus();
        return this.$swal.fire("", "연락처를 입력해주세요.", "warning");
      }
      if (!/^[0-9]{2,3}[0-9]{3,4}[0-9]{4}/.test(this.reqTel)) {
        this.$refs.txt_cTel.focus();
        return this.$swal.fire('', '연락처 형식이 올바르지 않습니다.', 'question');
      }
      if (!this.reqInfo.reqSpRemarks) {
        this.$refs.txt_reqSpRemarks.focus();
        return this.$swal.fire("", "문의 내용을 입력해주세요.", "warning");
      }

      this.reqInfo.insDate   = today;
      this.reqInfo.reqStatus = "IQ";

      let resIns_Request = await this.$api("/api/inquiryInsert", {
        param: [
          "PD", this.reqInfo.reqTitle, this.reqName, this.reqInfo.perCnt,
          this.reqInfo.reqEmail, this.reqTel, "N", this.reqInfo.reqSpRemarks,
          this.ruleAgree, this.reqInfo.reqStatus, this.userInfo,
          this.productId, this.reqInfo.iqCode
        ]
      });

      if (Object.keys(resIns_Request)[0] === 'error') {
        this.$swal.fire('', '문의 등록 중 오류가 발생했습니다.<br>문의처: 1660-4602', 'error')
      } else {
        this.sendKakao("IQ")
        this.$swal.fire('', '문의가 등록되었습니다.<br>빠른 시간 내에 답변드리겠습니다.', 'success');
        location.reload(true)
      }
    },

    async sendKakao(param) {
      let insKSendHistory = await this.$api("/api/insKSendHistory", {
        param: [this.reqInfo.iqCode, param, this.userInfo]
      });
      if (insKSendHistory.affectedRows > 0) {
        if (param == "IQ") {
          let kakaoAlimData = {
            clientName: this.reqName,
            clientCall: this.reqTel,
            iqCode:     this.reqInfo.iqCode,
            alimFlag:   param
          };
          this.$api("api/kakaoAlimSend3", {
            param: [{ kakaoAlimData }]
          }).then(res => console.log(res));
        }
      }
    },

    goBack() { history.back(); }
  }
}
</script>

<style scoped>
/* ── 변수 ── */
.pi-wrap {
  --green:      #86cd53;
  --green-dark: #5fa033;
  --green-lt:   #d4f0b8;
  --green-xlt:  #f0fbe7;
  --charcoal:   #2b3a2b;
  --bg:         #f5faf2;
  --border:     #ddefd4;
  --white:      #ffffff;
  --text-main:  #1a2e1a;
  --text-sub:   #5a7a5a;
  --text-muted: #8aaa8a;
  --red:        #e53935;
  --radius:     14px;
  --radius-sm:  8px;

  background: var(--bg);
  min-height: 100vh;
  padding: 3rem 1rem 5rem;
  font-family: 'Noto Sans KR', sans-serif;
}

.pi-inner {
  max-width: 640px;
  margin: 0 auto;
}

/* ── 헤더 ── */
.pi-header {
  text-align: center;
  margin-bottom: 1.5rem;
}
.pi-header-badge {
  display: inline-block;
  background: var(--green-lt);
  color: var(--green-dark);
  font-size: .75rem;
  font-weight: 700;
  letter-spacing: .1em;
  padding: .28rem 1rem;
  border-radius: 20px;
  margin-bottom: .8rem;
}
.pi-title {
  font-size: 1.75rem;
  font-weight: 800;
  color: var(--charcoal);
  margin: 0 0 .5rem;
}
.pi-sub {
  font-size: .88rem;
  color: var(--text-sub);
  line-height: 1.7;
  margin: 0;
}
.pi-kakao {
  font-size: .78rem;
  color: var(--text-muted);
}

/* ── 상품 배지 ── */
.pi-product-badge {
  display: flex;
  align-items: center;
  gap: .5rem;
  background: var(--charcoal);
  color: #fff;
  font-size: .82rem;
  padding: .65rem 1.2rem;
  border-radius: var(--radius-sm);
  margin-bottom: 1rem;
}
.pi-product-badge i  { color: var(--green); font-size: .95rem; }
.pi-product-badge span { color: #aaa; }
.pi-product-badge strong { font-weight: 700; letter-spacing: .04em; }

/* ── 카드 ── */
.pi-card {
  background: var(--white);
  border: 1px solid var(--border);
  border-radius: var(--radius);
  box-shadow: 0 4px 24px rgba(90,160,51,.08);
  padding: 2rem;
}
@media (max-width: 600px) {
  .pi-card { padding: 1.4rem; }
}

/* ── 개인정보 동의 아코디언 ── */
.pi-agree-wrap {
  border: 1.5px solid var(--border);
  border-radius: var(--radius-sm);
  overflow: hidden;
  margin-bottom: 1rem;
  transition: border-color .15s;
}
.pi-agree-wrap.open {
  border-color: var(--green);
}
.pi-agree-toggle {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: .85rem 1rem;
  background: var(--green-xlt);
  border: none;
  cursor: pointer;
  font-size: .88rem;
  color: var(--text-main);
  text-align: left;
  font-family: inherit;
}
.pi-agree-toggle:hover { background: #e6f7d9; }
.pi-agree-left {
  display: flex;
  align-items: center;
  gap: .6rem;
}
.pi-agree-toggle i { color: var(--text-muted); font-size: .85rem; flex-shrink: 0; }
.pi-checkbox {
  width: 17px;
  height: 17px;
  accent-color: var(--green-dark);
  cursor: pointer;
  flex-shrink: 0;
}
.pi-req { color: var(--red); }
.pi-agree-body {
  padding: 1.2rem 1.2rem 1rem;
  font-size: .82rem;
  color: var(--text-sub);
  line-height: 1.8;
  border-top: 1px solid var(--border);
  background: #fafffe;
}
.pi-agree-body h4 {
  font-size: .85rem;
  font-weight: 700;
  color: var(--charcoal);
  margin: 1rem 0 .35rem;
}
.pi-agree-body h4:first-child { margin-top: 0; }
.pi-agree-body ul {
  padding-left: 1.2rem;
  margin: 0 0 .5rem;
}
.pi-agree-body p { margin: 0 0 .5rem; }

/* ── 구분선 ── */
.pi-divider {
  height: 1px;
  background: var(--border);
  margin: 1.4rem 0;
}

/* ── 필드 ── */
.pi-field {
  margin-bottom: 1.3rem;
}
.pi-row {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 1rem;
}
@media (max-width: 600px) {
  .pi-row { grid-template-columns: 1fr; }
}
.pi-label {
  display: block;
  font-size: .78rem;
  font-weight: 700;
  color: var(--text-sub);
  text-transform: uppercase;
  letter-spacing: .04em;
  margin-bottom: .45rem;
}
.pi-input,
.pi-textarea {
  width: 100%;
  box-sizing: border-box;
  padding: .75rem 1rem;
  border: 1.5px solid #d4e6c3;
  border-radius: var(--radius-sm);
  font-size: .9rem;
  color: var(--text-main);
  background: #fff;
  outline: none;
  transition: border-color .15s, box-shadow .15s;
  font-family: inherit;
}
.pi-input:focus,
.pi-textarea:focus {
  border-color: var(--green);
  box-shadow: 0 0 0 3px rgba(134,205,83,.15);
}
.pi-textarea {
  min-height: 150px;
  resize: vertical;
  line-height: 1.6;
}
.pi-char-count {
  text-align: right;
  font-size: .72rem;
  color: var(--text-muted);
  margin-top: .3rem;
}

/* ── 버튼 ── */
.pi-btns {
  display: flex;
  gap: .8rem;
  margin-top: .5rem;
}
.pi-btn {
  flex: 1;
  padding: .9rem;
  font-size: .95rem;
  font-weight: 700;
  border: none;
  border-radius: var(--radius-sm);
  cursor: pointer;
  transition: all .2s;
  font-family: inherit;
}
.pi-btn-cancel {
  background: #f0f4f0;
  color: var(--text-sub);
  border: 1px solid var(--border);
}
.pi-btn-cancel:hover { background: #e4ede4; }
.pi-btn-submit {
  background: var(--charcoal);
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: .4rem;
}
.pi-btn-submit:hover { background: var(--green-dark); }
</style>